<template>
  <svg class="ml-1" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 5.00464H9V7.00464H11V5.00464Z" fill="currentColor" />
    <path d="M11 8.0046H9V15H11V8.0046Z" fill="currentColor" />
    <path
      d="M10 2C14.4 2 18 5.6 18 10C18 14.4 14.4 18 10 18C5.6 18 2 14.4 2 10C2 5.6 5.6 2 10 2ZM10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0Z"
      fill="currentColor"
    />
  </svg>
</template>
